import { render, staticRenderFns } from "./CategoryConsumptionPage.vue?vue&type=template&id=4aa8b0e4&scoped=true&"
import script from "./CategoryConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./CategoryConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8b0e4",
  null
  
)

export default component.exports